import _orderBy from "lodash/orderBy";
import _get from "lodash/get";
import _flatten from "lodash/flatten";
import store from "@/store/index";
import { transformPackages } from "@/utils/packages";
import { normalizeOrder } from "./order";

export async function orderPackages(packagesObj, orderObject) {
  orderObject = normalizeOrder(orderObject);

  const isArray = Array.isArray(packagesObj);

  const orderedPackages = _flatten(
    _orderBy(
      packagesObj,
      [p => _get(isArray ? p : p.find(p => p.selected), ...orderObject.path)],
      [orderObject.reversed ? "desc" : "asc"]
    )
  );

  if (isArray) return orderedPackages;
  else return await transformPackages(orderedPackages);
}

export function dispatchOrder(path, reversed) {
  store.dispatch("computerPackage/orderMergedPackages", {
    path: path,
    reversed: !!reversed
  });
}

export function dispatchGroupOrder(path, reversed) {
  store.dispatch("groupPackage/orderMergedPackages", {
    path: path,
    reversed: !!reversed
  });
}
